import { WeatherSchema } from '../schema/weather_schema.js';
import { ServiceBase } from './service_base.js';

class WeatherService extends ServiceBase {
  /**
   * Returns weather forecast.
   */
  getWeather(data) {
    return this.weatherRequest('get', data);
  }

  getSchema(data) {
    switch (data.module) {
      case 'weather':
        return WeatherSchema[data.action];
    }
  }
}

export { WeatherService };
